import { call, put, takeEvery } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

import { signin } from "../../../helpers/backend.helper";

/**
 * Logout user
 * @param {*} param0
 */
function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(signin, {
      email: user.email,
      password: user.password,
    });
    localStorage.setItem("authUser", JSON.stringify(response?.data));
    yield put(loginSuccess(response?.data));
    history.push("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

/**
 * Logout user if session not found
 */
function* logoutUser() {
  try {
    localStorage.removeItem("authUser");
    yield put(logoutUserSuccess(LOGOUT_USER, true));
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
